import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-2225">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2226">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#056ab8] tracking-tight" data-id="element-2227">
          FAQ - Frequently Asked Questions
        </h1>
      </div>
    </div>;
}